import React, { PureComponent } from 'react';
import './ConfirmationDialog.css';
import DialogWrapper from '../DialogWrapper/DialogWrapper';

class ConfirmationDialog extends PureComponent {
  render() {
    return (
      <DialogWrapper
        onClickCancel={this.props.onClickCancel}
        onClickMainAction={this.props.onClickMainAction}
        open={this.props.open}
        title={this.props.title}
        disableMainAction={this.props.disableMainAction}
        mainActionLabel={this.props.mainActionLabel}
        qaTag="qa-confirmdialog"
      >
        <span style={{ width: '100%', whiteSpace: 'pre-wrap' }}>{this.props.messageToConfirm}</span>
      </DialogWrapper>
    );
  }
}

ConfirmationDialog.defaultProps = {
  title: 'Confirm',
  mainActionLabel: 'Ok',
  disableMainAction: false,
};

export default ConfirmationDialog;
